import { gql } from '@apollo/client';

const GET_CAR = gql`
  query car {
    car {
      carId
      createdAt
      brand
      model
      year
      price
      cit
      vehicleType
    }
  }
`;

const CREATE_CAR = gql`
  mutation createCar($createCarInput: CreateCarInput) {
    createCar(createCarInput: $createCarInput) {
      brand
      model
      year
      price
      cit
      carId
      createdAt
      vehicleType
    }
  }
`;

const GET_MODELS = gql`
  query getModels($brand: String!) {
    getModels(brand: $brand)
  }
`;

const carOperations = {
  GET_CAR,
  CREATE_CAR,
  GET_MODELS,
};

export default carOperations;
